import type { TranslateFn, U2000ApiErrorResult } from "../u2000Core/axios/U2000HandleApiError";
import type { U2000SearchPayload, U2000SearchParameter } from "../u2000Core/components/tables/basic/U2000BasicTable";
import { U2000GenerateUrlUUID } from "../u2000Core/tools/U2000UrlHelpers";

const DISTRICTCADASTRE_URL = "U3143";

type DistrictCadastreEndpointsType = {
  INITLU: string;
  SEARCH: string;
  GET: (id: string | number) => string;
  CREATE: string;
  UPDATE: (id: string | number) => string;
  DELETE: (id: string | number) => string;
  AUDITS: (id: string | number) => string;
  FINDDISTRICTS: string;
  EXPORT_EXCEL: string;
};

const DistrictCadastreEndpoints: DistrictCadastreEndpointsType = {
  INITLU: `${DISTRICTCADASTRE_URL}/initLU`,
  SEARCH: `${DISTRICTCADASTRE_URL}/search`,
  GET: (id: string | number) => `${DISTRICTCADASTRE_URL}/${id}`,
  CREATE: `${DISTRICTCADASTRE_URL}/create`,
  UPDATE: (id: string | number) => `${DISTRICTCADASTRE_URL}/update/${id}`,
  DELETE: (id: string | number) => `${DISTRICTCADASTRE_URL}/delete/${id}`,
  AUDITS: (id: string | number) => `${DISTRICTCADASTRE_URL}/${id}/audits`,
  FINDDISTRICTS: `${DISTRICTCADASTRE_URL}/findDistricts`,
  EXPORT_EXCEL: `${DISTRICTCADASTRE_URL}/exportExcel`,
};

export interface DistrictCadastre {
  id: string;
  codeDistrict: string;
  propertyDistrict: string;
  version?: number;
  cadastres?: Cadastre[];
  organization?: {
    id: string;
    uuid: string;
    organizationName: string;
  };
  createdAt?: Date;
  updatedAt?: Date;
  deletedAt?: Date | null;
}

export interface Cadastre {
  id: string;
  idChecked?: boolean;
  cadastreCode: string;
  cadastre: string;
  rankCode: string;
  rankLabel: string;
  version?: number;
  districtCadastre?: DistrictCadastre;
  createdAt?: Date;
  updatedAt?: Date;
  deletedAt?: Date | null;
}

export const emptyDistrictCadastre: DistrictCadastre = {
  id: "",
  codeDistrict: "",
  propertyDistrict: "",
  version: undefined,
  cadastres: [],
};

export const emptyCadastre: Cadastre = {
  id: "",
  idChecked: false,
  cadastreCode: "",
  cadastre: "",
  rankCode: "",
  rankLabel: "",
  version: undefined,
};

import type { AxiosInstance } from "axios";

export const doInitLU = (axios: AxiosInstance) => {
  return axios.get(DistrictCadastreEndpoints.INITLU);
};

export const doSearch = (axios: AxiosInstance, searchPayload: U2000SearchPayload) => {
  return axios.post(DistrictCadastreEndpoints.SEARCH, searchPayload);
};

export const doGetData = (axios: AxiosInstance, id: string | number, forceRefresh?: boolean) => {
  const params = {
    ...(forceRefresh && { b: U2000GenerateUrlUUID() }),
  };
  return axios.get(DistrictCadastreEndpoints.GET(id), { params });
};

export const doCreateData = (axios: AxiosInstance, data: DistrictCadastre) => {
  return axios.post(DistrictCadastreEndpoints.CREATE, data);
};

export const doUpdateData = (axios: AxiosInstance, id: string | number, data: DistrictCadastre) => {
  return axios.post(DistrictCadastreEndpoints.UPDATE(id), data);
};

export const doDeleteData = (axios: AxiosInstance, id: string | number, data?: any) => {
  return axios.post(DistrictCadastreEndpoints.DELETE(id), data);
};

export const doGetAuditsData = (axios: AxiosInstance, id: string | number) => {
  const params = {
    b: U2000GenerateUrlUUID(),
  };
  return axios.get(DistrictCadastreEndpoints.AUDITS(id), { params });
};

export type U3143AutoCompletCriterias = { fieldName: string; value: unknown }[];

export interface U3143FindDistrictItem {
  id: string;
  codeDistrict?: string;
  propertyDistrict?: string;
}

export const doFindDistricts = (axios: AxiosInstance, criterias: U3143AutoCompletCriterias) => {
  return axios.post(DistrictCadastreEndpoints.FINDDISTRICTS, criterias);
};

// API Calls - Export Excel
export const doExportExcel = (axios: AxiosInstance, filter: U2000SearchParameter, lang?: "fr" | "en") => {
  return axios.post(DistrictCadastreEndpoints.EXPORT_EXCEL, { filter, lang });
};

// eslint-disable-next-line @typescript-eslint/no-unused-vars
export function districtCadastreHandleApiError(_t: TranslateFn, _NS: string, _err: unknown, _errorResult: U2000ApiErrorResult) {
  // Gestion des erreurs spécifiques au module U3143
  // À compléter selon les besoins du backend
}
